import { render, staticRenderFns } from "./partsOrder.vue?vue&type=template&id=5fed9b03&scoped=true"
import script from "./partsOrder.vue?vue&type=script&lang=js"
export * from "./partsOrder.vue?vue&type=script&lang=js"
import style0 from "./partsOrder.vue?vue&type=style&index=0&id=5fed9b03&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fed9b03",
  null
  
)

export default component.exports